export const MASTER_DATA_OBJECTS = {
	Worker: 'Worker',
	WorkExperienceOverview: 'WorkExperienceOverview',
	WorkerCertification: 'WorkerCertification',
	WorkExperience: 'WorkExperience',
	WorkerExpense: 'WorkerExpense',
	Job: 'Job',
}

export const MASTER_DATA_FIELDS = {
	discipline: 'discipline',
	specialty: 'specialty',
	primarySpecialty: 'primary_specialty',
	secondarySpecialty: 'secondary_specialty',
	licenseState: 'state',
	preferredLocations: 'preferred_locations',
	unitSpecialty: 'unit_specialty',
	agency: 'agency',
	referral: 'referral_method',
	charting: 'charting_software_used',
	referralRelationship: 'referral_relationship',
	category: 'category',
	shifts: 'shifts',
	documentType: 'support_document',
	state: 'state',
	jobType: 'job_type',
	facilityTypes: 'facility_types',
	timezoneIdentifiers: 'timezone_identifiers',
	candidateType: 'candidate_type',
	jobApplicantStatus: 'job_applicant_status',
	savedFilterFrequencies: 'saved_filter_frequencies',
	savedFilterPauseAlertPeriods: 'saved_filter_pause_alert_periods',
	savedFilterNotificationChannels: 'saved_filter_notification_channels',
	workerPostHireContent: 'worker_current_pipeline_stage_content',
	credentialVisibleFields: 'credential_visible_fields',
	candidatePostHireContent: 'candidate_type_pipeline_stage_contents',
	degreeLevel: 'degree_levels',
}
